import { COVERS } from '@/mocks/kanliao';

export default function Featured() {
  return (
    <section className="w-full py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        {/* section heading */}
        <div className="mb-7 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="flex items-end gap-4">
            <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
              本日精选 · 封面直达
            </h2>
            <span className="mb-1 hidden h-8 w-1 rounded-full bg-accent-500 sm:block" />
          </div>
          <p className="max-w-sm text-xs leading-5 text-foreground-500 sm:text-sm">
            每张封面都是一个精选合集入口，标题优先、挑顺眼的点开直达。
          </p>
        </div>

        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 md:gap-5">
          {COVERS.map((c) => (
            <button
              key={c.index}
              type="button"
              className="group flex cursor-pointer flex-col text-left"
              aria-label={`进入精选合集 ${c.title}`}
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-background-100">
                <img
                  src={c.image}
                  alt={`${c.title}精选封面`}
                  title={`${c.title} · ${c.category}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent" />

                {/* cover index watermark */}
                <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2 py-1 font-heading text-[10px] font-bold tracking-widest text-foreground-900">
                  {c.index}
                </span>

                {/* cover caption */}
                <div className="absolute inset-x-0 bottom-0 p-3 md:p-4">
                  <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-background-200">
                    {c.category}
                  </span>
                  <h3 className="mt-1 font-heading text-lg font-black leading-snug text-background-50 md:text-xl">
                    {c.title}
                  </h3>
                  <p className="mt-1 hidden truncate text-xs text-background-200/90 md:block">{c.sub}</p>
                  <div className="mt-2 flex items-center gap-2 text-[11px] text-background-200">
                    <span>{c.tags} 个入口</span>
                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 text-background-50 transition-transform group-hover:translate-x-1">
                      <i className="ri-arrow-right-line text-xs" />
                    </span>
                  </div>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}